// TODO(James) these should go in `testing/constants` and only be used in testing environments
// TODO(James) we should enforce w/ eslint (import plugin might help here) that only tests/stories import from `testing/constants`

// TODO(James) revisit this implementation when we integrate into the CMS
export const REFER_A_FRIEND_TARGET = 'refer-a-friend';

export const LOGGEDIN_LINKS = [
  { target: '/account', text: 'My plan' },
  { target: '/account/my-info/', text: 'My info' },
  { target: REFER_A_FRIEND_TARGET, text: 'Refer a friend' },
  { target: '/faqs/', text: 'Support & FAQ' },
];

export const LOGGEDOUT_LINKS = [
  { target: '/how-it-works/', text: 'How It Works' },
  { target: '/fresh-dog-food/', text: 'Recipes' },
  { target: '/faqs/', text: 'FAQ' },
  { target: '/reviews/', text: 'Reviews' },
  { target: '/about/', text: 'About' },
];

export const LOGO_URL = '/';

export const LOGO_SR_TEXT = 'Ollie logo';
